import React, { Component } from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

class PageHeader extends Component {

  render() {
    const { title, desc } = this.props;
    return (
      <div className="row">
        <div className="col-lg-12">
          <h1>
            {title}
            {
              desc ?
                <>
                  {' '}
                  <Tooltip title={desc}><InfoCircleOutlined style={{ fontSize: '14px' }} /></Tooltip>
                </>
                : null
            }
          </h1>

        </div>
      </div>


    );
  }

}

export default PageHeader;